import { render, staticRenderFns } from "./InstructorProfile.vue?vue&type=template&id=2ececbcb&scoped=true&"
import script from "./InstructorProfile.vue?vue&type=script&lang=js&"
export * from "./InstructorProfile.vue?vue&type=script&lang=js&"
import style0 from "./InstructorProfile.vue?vue&type=style&index=0&id=2ececbcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ececbcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
